module.exports = __webpack_public_path__ + "static/media/printer.7ff34438.svg";